var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "13px",
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "in-file-/-Beitrag-teilen",
    transform: "translate(-296.000000, -20.000000)",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(129.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.029229,9.4331374 L184.345512,15.1090909 L167.793151,15.1090909 L174.041687,9.49360289 L174.450147,9.8365007 C175.368887,10.6088985 176.630321,10.6081183 177.54906,9.8365007 L177.54906,9.8365007 L178.029229,9.4331374 Z M167.180261,3.72792641 L173.272307,8.84681726 L167,14.4833707 L167,4.41294183 C167,4.16483829 167.06537,3.93116845 167.180261,3.72792641 L167.180261,3.72792641 Z M184.819739,3.72831651 C184.93463,3.93077835 185,4.16483829 185,4.41294183 L185,4.41294183 L185,14.3585387 L178.799005,8.78635178 Z M183.565039,3 C183.733019,3 183.89466,3.02847729 184.044416,3.08114078 L184.044416,3.08114078 L176.896949,9.0859485 C176.358146,9.53807428 175.641062,9.53846438 175.102258,9.0859485 L175.102258,9.0859485 L167.955584,3.08114078 C168.105736,3.02847729 168.266981,3 168.434961,3 L168.434961,3 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.4f19f197.svg";
export { ForwardRef as ReactComponent };